import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import InputWrapper from '../forms/InputWrapper.js';
import api from '../../api/index.js';

import "react-datepicker/dist/react-datepicker.css";


class FarmForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			FarmID: props.FarmID || false,
			FarmName: props.FarmName || props.filter || '',
			Address: props.Address || '',
			City: props.City || '',
			State: props.State || '',
			StartDate: api.date(props.StartDate) || new Date(),
			DiscontinuedDate: api.date(props.DiscontinuedDate) || new Date(),
		};
		
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onFarmAdded = this.onFarmAdded.bind(this);
		this.onReceiveFarms = this.onReceiveFarms.bind(this);
	}
	
	onChange(e) {
		this.setState({[e.target.name]: e.target.value});
	}
	
	async onSubmit(e) {
		e.preventDefault();
		
		const fielddata = Object.assign({}, this.state);
		fielddata['StartDate'] = fielddata['StartDate'].api();
		
		if (this.props.discontinued)
			fielddata['DiscontinuedDate'] = fielddata['DiscontinuedDate'].api();
		else
			delete fielddata.DiscontinuedDate;

		if (this.state.FarmID === false) {
			try {
				let r = await api.post('farms', fielddata);
				api.success('Farm added', r);
				if (this.props.onAdded)
					this.props.onAdded(r);
			} catch(e) {
				api.handleExceptions(e);
			};
		} else {
			try {
				let r = await api.put('farms/' + this.state.FarmID, fielddata);
				api.success('Farm updated', r);
				if (this.props.onUpdated)
					this.props.onUpdated(this.state.FarmID);
			} catch(e) {
				api.handleExceptions(e);
			};
		}
	}
	
	
	onFarmAdded(id) {
		if (this.props.onAdded)
			this.props.onAdded(id);
	}
	
	// Get back the entire list
	onReceiveFarms(data) {
		for(let i=0; i < data.length; i++) {
			if (data[i].FarmID === this.state.FarmID) {
				// Update state
				let o = {};
				for(var prop in data[i]) {
					if (this.state.hasOwnProperty(prop))
						o[prop] = data[i][prop];
				}
				this.setState(o);
			}
		}
	}

	onDateChange = (date) => {
		console.log("DateChange", date);
		this.setState({
			StartDate: date
		});
	}


	onDiscontinuedDateChange = (date) => {
		console.log("DiscontinuedDateChange", date);
		this.setState({
			DiscontinuedDate: date
		});
	}


	componentDidUpdate(prevProps) {
		const fid = this.props.FarmID || false;
		if (this.state.FarmID !== fid) {
			this.setState({
				FarmID: this.props.FarmID || false,
				FarmName: this.props.FarmName || '',
				Address: this.props.Address || '',
				City: this.props.City || '',
				State: this.props.State || ''
			});
		}
	} 
	
	render() {
		const discontinued = !this.props.discontinued ? '' : <>
						<label>Discontinued Date</label>
						<InputWrapper label=""  info="The date this farm went out of service.">
						<DatePicker
								selected={this.state.DiscontinuedDate}
								onChange={this.onDiscontinuedDateChange}
							/>
						</InputWrapper>
						</>;

		return (
			<div>
				<form className="interface" onSubmit={this.onSubmit}>
					<label>Name</label>
					<input type="text" name="FarmName" placeholder="Name" value={this.state.FarmName} onChange={this.onChange} />
					<label>Address</label>
					<input type="text" name="Address" placeholder="Address" value={this.state.Address} onChange={this.onChange} />
					<label>City</label>
					<input type="text" name="City" placeholder="City" value={this.state.City} onChange={this.onChange} />
					<label>State</label>
					<input type="text" name="State" placeholder="State" value={this.state.State} onChange={this.onChange} />
					<label>Start Date</label>
					<InputWrapper label=""  info="Purchase or lease date.">
					<DatePicker
							selected={this.state.StartDate}
							onChange={this.onDateChange}
						/>
					</InputWrapper>
					{discontinued}
					<input type="submit" value={this.state.FarmID ? "Save this farm" : "Add this farm"} />
				</form>
			</div>
		);
	}
}

export default FarmForm;
